import { useFetch, useListener } from "@hyper-fetch/react";

import { sdk, socketSdk } from "@/api/sdk";
import { NavCountBadge } from "@/components/layouts/page/sidebar/components/nav-count-badge";
import { useBookingClient } from "@/features/booking/hooks/use-booking-client";
import { splitBookings } from "@/features/booking/modules/client-bookings/bookings-view";
import { m } from "@/paraglide/messages.js";

/**
 * Visits waiting on the client ("pick a new time", "will you be there?") on the menu's
 * "My bookings" pill. Same request as the page, so both share one cache entry.
 */
export function BookingsNavBadge() {
  const booking = useBookingClient();
  const bookings = useFetch(sdk.bookingClient.bookings.$get.setQueryParams(booking.query), {
    disabled: !booking.linked,
    dependencies: [booking.query.organizationId ?? ""],
  });
  const incoming = useListener(socketSdk.notification.new.$listener);
  incoming.onEvent(({ data }) => {
    if (data.type.startsWith("booking.")) bookings.refetch();
  });

  const count = splitBookings(bookings.data).needsAnswer.length;
  return <NavCountBadge count={count} label={m.booking_portal_nav_bookings_badge({ count: String(count) })} />;
}
